module.exports = __webpack_public_path__ + "img/horizontal_3_6_8011.36840c51.png";